/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, FlexContainer, Spacer, theme } from "@nordcloud/gnui";
import { ReportsSortFields, SortOrder } from "~/generated/graphql";
import { SortSelector } from "~/components/SortSelector";
import { TABLE_LABELS } from "~/constants";
import { useQueryState } from "~/hooks";
import { ReportsQuery } from "~/views/resources/types";
import { ReportsFiltersSidebar } from "./ReportsFiltersSidebar";
import { ReportsSearch } from "./ReportsSearch";

const sortOptions = [
  {
    value: ReportsSortFields.DateGenerated,
    label: "Date Generated",
  },
  {
    value: ReportsSortFields.CreatedBy,
    label: TABLE_LABELS.createdBy,
  },
];

export function ReportsListHeader({
  resultsCount = 0,
}: {
  resultsCount?: number;
}) {
  const {
    queryState: { field, order },
    updateQueryState,
  } = useQueryState<ReportsQuery>();

  const handleSortDirection = (sortOrder: SortOrder) => {
    updateQueryState({
      order: sortOrder,
    });
  };

  const handleSortField = (sortField: ReportsSortFields) => {
    updateQueryState({
      field: sortField,
    });
  };

  return (
    <Box boxStyle="lightGrey" spacing="spacing04">
      <FlexContainer justifyContent="space-between">
        <SortSelector<ReportsSortFields>
          options={sortOptions}
          value={field ?? ReportsSortFields.DateGenerated}
          direction={order ?? SortOrder.Desc}
          onSelect={handleSortField}
          onSortChange={handleSortDirection}
        />
        <Spacer width={theme.spacing.spacing04} />
        <ReportsSearch />
        <Spacer width={theme.spacing.spacing04} />
        <ReportsFiltersSidebar resultsCount={resultsCount} />
      </FlexContainer>
    </Box>
  );
}
